import React, { useState, useEffect } from "react";
import { lang } from "../../lang";
import "./FlashCardEditor.css";

// Difficulty levels are no longer set here, but kept for potential future use elsewhere
// const difficultyLevels = [
//   { value: 'easy', label: lang.flashCards.difficultyLevels.easy || "Easy" },
//   { value: 'moderate', label: lang.flashCards.difficultyLevels.moderate || "Moderate" },
//   { value: 'hard', label: lang.flashCards.difficultyLevels.hard || "Hard" },
//   { value: 'mildPanic', label: lang.flashCards.difficultyLevels.mildPanic || "Mild Panic" },
//   { value: 'gotcha', label: lang.flashCards.difficultyLevels.gotcha || "Gotcha!" },
//   { value: null, label: lang.flashCards.difficultyLevels.none || "None" },
// ];

function FlashCardEditor({
  isOpen,
  onClose,
  onSave,
  existingCardData,
  topicCategories = [],
}) {
  const [frontContent, setFrontContent] = useState("");
  const [backContent, setBackContent] = useState("");
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  // const [difficulty, setDifficulty] = useState(null); // Difficulty removed from editor

  const isEditing = !!existingCardData;

  useEffect(() => {
    if (isOpen) {
      if (isEditing && existingCardData) {
        setFrontContent(existingCardData.frontContent || "");
        setBackContent(existingCardData.backContent || "");
        setSelectedCategoryIds(existingCardData.categoryIds || []);
        // setDifficulty(existingCardData.difficulty === undefined ? null : existingCardData.difficulty);
      } else {
        // Reset for new card
        setFrontContent("");
        setBackContent("");
        setSelectedCategoryIds([]);
        // setDifficulty(null);
      }
    }
  }, [isOpen, isEditing, existingCardData]);

  const handleCategoryToggle = (categoryId) => {
    setSelectedCategoryIds((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!frontContent.trim() || !backContent.trim()) {
      // Consider a more user-friendly notification system than alert
      alert("Front and back content cannot be empty.");
      return;
    }
    const cardData = {
      frontContent,
      backContent,
      categoryIds: selectedCategoryIds,
      difficulty: isEditing ? existingCardData.difficulty : null, // Preserve existing difficulty on edit, null for new
    };
    onSave(cardData, existingCardData?.id);
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="flashcard-editor modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="modal-title">
          {isEditing ? "Edit Flash Card" : "Add New Flash Card"}
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="cardFront">
              {lang.flashCards.frontLabel || "Front (Question/Statement):"}
            </label>
            <textarea
              id="cardFront"
              value={frontContent}
              onChange={(e) => setFrontContent(e.target.value)}
              placeholder="Enter question or statement..."
              rows="4"
            />
          </div>
          <div className="form-group">
            <label htmlFor="cardBack">
              {lang.flashCards.backLabel || "Back (Answer):"}
            </label>
            <textarea
              id="cardBack"
              value={backContent}
              onChange={(e) => setBackContent(e.target.value)}
              placeholder="Enter answer or details. Use <pre><code>...</code></pre> for code."
              rows="4"
            />
          </div>

          {topicCategories && topicCategories.length > 0 && (
            <div className="form-group">
              <label>{lang.flashCards.categoriesLabel || "Categories:"}</label>
              <div className="categories-checkbox-group">
                {topicCategories.map((category) => (
                  <label key={category.id} className="category-checkbox-item">
                    <input
                      type="checkbox"
                      checked={selectedCategoryIds.includes(category.id)}
                      onChange={() => handleCategoryToggle(category.id)}
                    />
                    {category.name}
                  </label>
                ))}
              </div>
            </div>
          )}

          {/* Difficulty selection removed from editor */}

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="button-cancel">
              Cancel
            </button>
            <button type="submit" className="button-save">
              {isEditing ? "Save Changes" : "Add Card"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FlashCardEditor;
